module.exports = __webpack_public_path__ + "static/media/Read.fd57b0ff.mp4";